<aside class="control-sidebar control-sidebar-dark" style="display: none;">

  <div class="p-3">
    <h5>[Title]</h5>
    <p>[Sidebar content]</p>
  </div>
</aside>

<footer class="main-footer">
  <div class="float-right d-none d-sm-inline">
    {{'@metadata.slogan' | translate }}
  </div>
  <strong>{{'@metadata.copyright' | translate }}&nbsp;<a href="https://direction.com.br" target="_blank"
      rel="noopener noreferrer">{{
      '@metadata.author' | translate }}</a>.</strong>
</footer>
<div id="sidebar-overlay" data-widget="pushmenu" (click)="showSideBarSearch()"></div>